import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'dynamic-checkbox',
    templateUrl: 'form-checkbox.component.html',
    styleUrls: ['form-checkbox.component.scss'],
})

export class FormCheckboxComponent extends FieldType {

}